export enum InfoSetDirection {
  ROW = 'row',
  COLUMN = 'column'
}
